/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ai_Level_2Inputs */



/**
* | output |
* | --- |
* | "Tried it a few times" |
*
* @param {Onboarding_Ai_Level_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_ai_level_2 = /** @type {((inputs?: Onboarding_Ai_Level_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ai_Level_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein paar Mal ausprobiert")
	return /** @type {LocalizedString} */ ("Tried it a few times")
});